module.exports = __webpack_public_path__ + "static/media/xepelin-bank.d646f7b2.svg";